module.exports = __webpack_public_path__ + "static/media/chester-wade.48a7de29.jpg";